import { modelT } from "../../redux/features/ui/ui.types";

export const modelsHeadboards: modelT[] = [
  {
    img: "/images/assets/CollectionImages/bed_size/38” modern.png",
    label: "38” modern",
    description: "38” modern",
    labelUI: "Sleek modern",
    nameValueThreekit: "headboard_Queen",
    configurationShortId: "LYFPf9dEQ",
    subcategory: "Headboards",
  },
  {
    img: "/images/assets/CollectionImages/bed_size/50” classic.png",
    label: "50” classic",
    description: "50” classic",
    labelUI: "Timeless look",
    nameValueThreekit: "headboard_Queen",
    configurationShortId: "R_UHbFYpH",
    subcategory: "Headboards",
  },
  {
    img: "/images/assets/CollectionImages/bed_size/70” luxe.png",
    label: "70” luxe",
    description: "70” luxe",
    labelUI: "Tall + luxe",
    nameValueThreekit: "headboard_Queen",
    configurationShortId: "YOakcpA_m",
    subcategory: "Headboards",
  },
];
